import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { intl } from "../utils/i18nUtility";
/**
 * Create a wrapper compose to support localization
 * @param ComposedComponent
 * @returns {{Component}}
 */

var withLocalization = function withLocalization(ComposedComponent) {
  return function (props) {
    return React.createElement(ComposedComponent, _extends({}, props, {
      intl: intl
    }));
  };
};

export default withLocalization;